import script from "./GlobalLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalLoader.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalLoader.vue?vue&type=style&index=0&id=036727c1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-036727c1"]])

export default __exports__